import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contact: [],
  loading: false,
  error: null,
  totalPages: 0,
  page: 1,
  detail: null,
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    fetchContactRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchContactSuccess: (state, action) => {
      state.loading = false;
      state.contact = action.payload.contact;
      state.totalPages = action.payload.totalPages;
      state.page = action.payload.currentPage;
    },
    fetchContactFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addContactRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    addContactSuccess: (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.contact.push(action.payload);
      }
    },
    addContactFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchContactRequest,
  fetchContactSuccess,
  fetchContactFailure,
  addContactRequest,
  addContactSuccess,
  addContactFailure,
} = contactSlice.actions;

export default contactSlice.reducer;
